/* eslint-disable prettier/prettier */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { fetchRedemptions } from 'src/services/urls'

const initialState = {
  loading: false,
  data: { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 },
  docs: [],
  error: '',
  pageSize: 10,
  activePage: 0,
  docsMap: {},
}

export const fetchAllRedemptions = createAsyncThunk(
  'transactions/fetchAllRedemptions',
  async (data, { dispatch, getState }) => {
    try {
      let query = '?'

      for (let key in data) {
        query += `${key}=${data[key]}&`
      }

      query = query.slice(0, -1)
      const url = fetchRedemptions(query)

      const response = await makeRequest(url)
      response.data.data.mobileNumber = data?.mobileNumber
      return response.data.data
    } catch (e) {
      handleGeneralError(e, { dispatch, showToast })
      return { error: e?.response?.data?.error?.message }
    }
  },
)

const redemptionSlice = createSlice({
  name: 'redemptions',
  initialState,
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    resetRedemption: (state, action) => {
      state.docs = []
      state.docsMap = {}
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllRedemptions.pending, (state, action) => {
      state.loading = action.meta.arg.firstLoad ? true : false
    })
    builder.addCase(fetchAllRedemptions.fulfilled, (state, action) => {
      state.loading = false
      state.error = action.payload.error

      if (!action.payload.error) {
        if (action.payload.docs && Array.isArray(action.payload.docs)) {
          /**
           * Code used to resolve pagination
           * react table needs page 1 and page 2 data to show page 2 data
           * to remove duplicate data hashMap "docsMap" is used
           */
          let newDocs = []

          for (let i = 0; i < action.payload.docs.length; i++) {
            if (!(action.payload.docs[i]._id in state.docsMap)) {
              newDocs.push(action.payload.docs[i])
              state.docsMap[action.payload.docs[i]._id] = action.payload.docs[i]._id
            }
          }

          if (action.mobileNumber) {
            state.docs = [...newDocs]
          } else {
            state.docs = [...state.docs, ...newDocs]
          }
        }
        state.data = action.payload
      }
    })
    builder.addCase(fetchAllRedemptions.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.docs = []
      state.error = action.error.message
    })
  },
})

export const { setActivePage, setPageSize, resetRedemption, setLoading } = redemptionSlice.actions
export default redemptionSlice.reducer
